import "../Styles/index.scss";

import { define } from "@wagich/svelte-light-element";

import Flickity from "flickity";
for (let element of document.querySelectorAll(".gallery-block__flickity")) {
	new Flickity(element, {
		pageDots: false,
		wrapAround: true,
	});
}

import BulmaTabs from "./components/bulma-tabs.svelte";
define("bulma-tabs", BulmaTabs);

import RouteMap from "./components/route-map.svelte";
define("route-map", RouteMap);

import OverviewMap from "./components/overview-map.svelte";
define("overview-map", OverviewMap);

// Defined right away but fetched only once one of these actually turns up in the document,
// so the chunks stay out of the initial bundle.
define("bluc-map", () => import("./components/bluc-map.svelte"));
define("custom-form", () => import("./custom-form/custom-form.svelte"));
define("ticket-shop", () => import("./ticket-shop/ticket-shop.svelte"));

document.querySelector("#navbarMenuToggle")?.addEventListener("click", () => {
	document.documentElement.classList.add("is-nav-open");
});
document.querySelector("#navOverlayClose")?.addEventListener("click", () => {
	document.documentElement.classList.remove("is-nav-open");
});

let navbarHints = document.querySelector(".navbar-hints");
if (navbarHints != null) {
	let trigger = navbarHints.querySelector(".navbar-hints__toggle");
	trigger?.addEventListener("click", e => {
		if (navbarHints.classList.contains("is-active")) {
			return;
		}

		let close = (e2: MouseEvent) => {
			let target = e2.target as Node
			if (navbarHints.contains(target) && !trigger.contains(target)) {
				return;
			}

			navbarHints.classList.remove("is-active");
			document.removeEventListener("click", close);
		};
		document.addEventListener("click", close);
		navbarHints.classList.add("is-active");
		e.stopPropagation();
	});

}
